import React from 'react';
import cn from 'classnames';
import css from "./style.scss"





const Plan=(props)=>{
  const onSelect = () => {
    props.onSelect(props.plan)
  }
  return (
    <div onClick={onSelect} className={cn(css.plan, props.selected === props.plan ? css.selected : "")}>
      <h4>{props.title}</h4>
      <div className={css.price}>
        {props.price}€
      </div>
      <div className={css.subprice}>Every {props.period}</div>
    </div>
  )
}

class CustomPlansUI extends React.Component {
  componentDidMount(){
    this.props.onSelect("15-accounts", "15-accounts-monthly")
  }
  renderPlans(){
    let period_plans=this.props.plans[this.props.selectedPeriod]
    return Object.keys(period_plans).map(n=>
      <Plan
        key={n}
        plan={n}
        title={period_plans[n].name}
        period={period_plans[n].period}
        price={period_plans[n].price}
        selected={this.props.selectedPlan}
        onSelect={this.props.onSelect}
      />
    )
  }
  render(){
    return (
      <div className={cn(css.container, css.customPlans)}>
        <div className={css.customText}>
          <h1>Our custom plans</h1>
          <h3 className={css.subtitle}>Seems like you have a lot of Instagram accounts! <b>We like that.</b></h3>

          <h2>Every custom plan offers:</h2>
          <ul>
            <li>Up to <b>10</b> Team Members</li>
            <li>Export and download all your data</li>
            <li>Remove all ads</li>
            <li>No 7 days limit for your stories!</li>
          </ul>
          <h3>Choose the number of accounts that best fits you:</h3>
        <div>
          <div className={css.plans}>
            {this.renderPlans()}
          </div>
          <label className={css.yearly_check}><input type="checkbox" onChange={this.props.onChangePeriod}/> Yearly (2 months free!) </label>
        </div>
        </div>
      </div>
    )
  }
}

export default CustomPlansUI



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/ui/custom_plans.js